import { Dropdown } from "primereact/dropdown"
import { useField } from "formik"

import { Skeleton } from "primereact/skeleton"

//Style
import styles from "../../../../styles/Form-Inputs.module.css"

/* export interface listOption{
    label: string,
    value: any
} */

/* interface Props{
    name: string,
    label: string,
    options: listOption[],
    placeHolderValue?: string, 
    disabled?: boolean;
    required?: boolean;
} */

export default function RefDropDown(props) {
  const [field, meta, helpers] = useField(props.name)

  const getDropDown = () => {
    if (props.isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <Dropdown
            value={field.value}
            {...props}
            placeholder={
              !props.placeHolderValue
                ? `Please select an entry`
                : props.placeHolderValue
            }
            onChange={(e) => {
              helpers.setValue(e.value)
            }}
            className={meta.touched && meta.error ? "p-invalid" : undefined}
          />
          {meta.touched && meta.error ? (
            <label id={`${props.name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  const labelField = () => {
    if (props.isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <label>
          {props.label}{" "}
          {props.required ? <span style={{ color: "red" }}> * </span> : null}
        </label>
      )
    }
  }

  return (
    <div className={styles.field}>
      <label>{labelField()}</label>
      {props.helpText ? (
        <div>
          <small style={{ color: "gray" }}>{props.helpText}</small>
        </div>
      ) : null}
      <div>{getDropDown()}</div>
    </div>
  )
}
